import { render, staticRenderFns } from "./VehicleTypeEditor.vue?vue&type=template&id=669b9d55&scoped=true"
import script from "./VehicleTypeEditor.vue?vue&type=script&lang=js"
export * from "./VehicleTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b9d55",
  null
  
)

export default component.exports